const user = {
  getUser: state => state.user,
  getUserRole: state => state.user ? state.user.attributes['custom:role'] : '',
  getUserTitle: state => state.user ? state.user.attributes['custom:title'] : '',
  getUserOrg: state => state.user ? state.user.attributes['custom:organization'] : '',
  getUserToUpdate: state => state.userToUpdate,
  getUserToDelete: state => state.userToDelete,
  getUsers: state => state.users,
  getIsUsersLoading: state => state.isUsersLoading,
  getUserError: state => state.userError,
};

export default user;
